import { PlayerStat } from "../types/tournament";

export interface PlayerStatUpDown extends PlayerStat {
  isPromoted?: boolean;
  isRelegated?: boolean;
}

export interface SimulationResult {
  mockStandings: Record<number, PlayerStatUpDown[]>;
  targetGroups: { groupName: string; players: PlayerStatUpDown[] }[];
}

export const generateStandardRules = (numGroups: number, moveCount: number) => {
  const rules = [];

  for (let g = 0; g < numGroups; g++) {
    const groupId = g; // Mock ID
  
    if (g > 0) {
      rules.push({
        targetGroupName: `Group ${g} (Box ${g})`,
        sources: [{
          sourceGroupIds: [groupId],
          positions: Array.from({length: moveCount}, (_, i) => i + 1), // Top X
          limit: moveCount
        }]
      });
    }
  }
  return rules;
};

export const simulateProgression = (
  numberOfGroups: number,
  numberOfPlayers: number,
  moveCount: number
): SimulationResult => {
  
  const baseGroupSize = Math.floor(numberOfPlayers / numberOfGroups);
  const remainder = numberOfPlayers % numberOfGroups;

  let userIdCounter = 1;
  const mockSourceGroups: Record<number, PlayerStatUpDown[]> = {};

  for (let g = 0; g < numberOfGroups; g++) {
    const groupId = g;
    mockSourceGroups[groupId] = [];
    const currentGroupSize = g < remainder ? baseGroupSize + 1 : baseGroupSize;

    for (let p = 0; p < currentGroupSize; p++) {
      const rank = p + 1;
      const stat: PlayerStatUpDown = {
        userId: userIdCounter++,
        groupId: groupId,
        rank: rank,
        isAllocated: false,
      };
      mockSourceGroups[groupId].push(stat);
    }
  }

  const targetGroups: { groupName: string; players: PlayerStatUpDown[] }[] = [];

  for (let g = 0; g < numberOfGroups; g++) {
    targetGroups.push({ groupName: `Box ${g+1}`, players: [] });
  }

  for (let g = 0; g < numberOfGroups; g++) {
    const groupId = g;
    const players = mockSourceGroups[groupId];
    const groupSize = players.length;

    players.forEach(p => {
      let targetBoxIndex = g;

      const isTopBox = g === 0;
      const isBottomBox = g === numberOfGroups - 1;

      if (!isTopBox && p.rank <= moveCount) {
        targetBoxIndex = g - 1;
        p.isPromoted = true;
        p.destinationGroup = `Box ${targetBoxIndex}`;
        p.isAllocated = true;
      }
      else if (!isBottomBox && p.rank > (groupSize - moveCount)) {
        targetBoxIndex = g + 1;
        p.isRelegated = true;
        p.destinationGroup = `Box ${targetBoxIndex}`;
        p.isAllocated = true;
      } else {
        p.destinationGroup = `Box ${targetBoxIndex}`;
      }
      
      targetGroups[targetBoxIndex].players.push(p);
    });
  }

  return { mockStandings: mockSourceGroups, targetGroups };
};